import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { UserProfileModel } from './models/user-profile.model';
import { plainToClass } from 'class-transformer';
import { AuthService as SocialAuthService, FacebookLoginProvider } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
import { ProfileCheckModel } from './models/profile-check.model';
import { EnvironmentSettingsModel } from './models/environment-settings.model';
import { SignUpModel } from './models/sign-up.model';
import { GoogleLoginModel } from './models/google-login.model';
import { FacebookLoginModel } from './models/facebook-login.model';
import { BiodigitalLoginModel } from './models/biodigital-login.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "angularx-social-login";
var AuthService = /** @class */ (function () {
    function AuthService(http, socialAuthService) {
        this.http = http;
        this.socialAuthService = socialAuthService;
    }
    AuthService.prototype.loginWithBiodigital = function (login) {
        return this.http.post('/ws/user/sign/in', BiodigitalLoginModel.toJSON(login));
    };
    AuthService.prototype.loginWithGoogle = function (login) {
        return this.http.post('/ws/user/sign/in/google', GoogleLoginModel.toJSON(login));
    };
    // Deprecated
    AuthService.prototype.loginWithFacebook = function (login) {
        return this.http.post('/ws/user/sign/in/facebook', FacebookLoginModel.toJSON(login));
    };
    AuthService.prototype.logout = function () {
        return this.http.get('/ws/user/sign/out');
    };
    AuthService.prototype.checkProfile = function (email) {
        return this.http.post('/ws/user/profile/check', { version: 2, email: email })
            .pipe(map(function (result) {
            var profileCheck = ProfileCheckModel.fromJSON(result);
            profileCheck.isThirdParty = profileCheck.thirdPartyProvider !== '';
            return profileCheck;
        }));
    };
    AuthService.prototype.getUserProfile = function () {
        return this.http.get('/ws/user/profile')
            .pipe(map(function (result) {
            result.organizations = JSON.parse(result.organizations);
            return plainToClass(UserProfileModel, result);
        }));
    };
    AuthService.prototype.getEnvironmentSettings = function () {
        return this.http.get('/ws/environment/settings?version=2')
            .pipe(map(function (result) {
            return EnvironmentSettingsModel.fromJSON(result);
        }));
    };
    /**
     * Gets a list of user apps
     */
    AuthService.prototype.getUserApps = function () {
        return this.http.get('/ws/developer/apps/profile')
            .pipe(map(function (result) { return result && result.apps ? JSON.parse(result.apps) : []; }));
    };
    AuthService.prototype.getGroupConfigFromRoute = function (snapshot) {
        var group = snapshot.queryParams.group || '';
        var groupCode = snapshot.queryParams.code || '';
        var invitation = snapshot.queryParams.group_invite || '';
        var config = {
            group: group,
            groupCode: groupCode,
            groupCodeMode: group !== '' ? 1 : 0,
            groupInviteMode: invitation !== '' ? 1 : 0,
            groupInviteKey: invitation
        };
        return config;
    };
    AuthService.prototype.isLoggedIn = function () {
        // Uses version 2, which responds with 200 status for good, 401 if not
        return this.http.get('/ws/user/is/signed-in?version=2');
    };
    AuthService.prototype.getProfileRestrictions = function (profile) {
        var emailRestricted = false;
        var ipRestricted = false;
        var name = '';
        profile.organizations.forEach(function (organization) {
            if (emailRestricted || ipRestricted) {
                return;
            }
            name = organization.name;
            emailRestricted =
                organization.user_is_subscribed &&
                    organization.email_domain_restriction &&
                    !organization.user_has_email_domain_access;
            ipRestricted =
                organization.user_is_subscribed &&
                    organization.ip_address_restriction &&
                    !organization.user_has_domain_access;
            if (emailRestricted || ipRestricted) {
            }
        });
        return {
            organizationName: name,
            email: emailRestricted,
            ip: ipRestricted
        };
    };
    AuthService.prototype.resetPassword = function (email) {
        return this.http.post('/ws/user/password/forgot', { email: email });
    };
    AuthService.prototype.signUp = function (value) {
        return this.http.post('/ws/user/sign/up', SignUpModel.toJSON(value));
    };
    AuthService.prototype.authenticateWithGoogle = function () {
        return this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
    };
    AuthService.prototype.authenticateWithFacebook = function () {
        return this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
    };
    AuthService.ngInjectableDef = i0.defineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
